export default {
  'attachment': {
    'title': '附件管理',

    'search_keywords': '请输入关键字',
    'search_status': '状态',
    'search_btn': '搜索',
    'search_open': '启用',
    'search_close': '禁用',
    'search_asc': '正序',
    'search_desc': '倒叙',

    'name': '文件名',
    'size': '文件大小',
    'type': '文件类型',
    'create_time': '添加时间',
    'status': '状态',
    'open': '启用',
    'close': '禁用',
    'action': '操作',
    'detail': '详情',
    'download': '下载',
    'delete': '删除',
    'attachment_detail': '附件详情',

    'detail_id': 'ID',
    'detail_belong': '属于',
    'detail_name': '文件名',
    'detail_path': '存储位置',
    'detail_mime': '文件Mime',
    'detail_type': '文件类型',
    'detail_size': '文件大小',
    'detail_md5': '文件md5',
    'detail_sha1': '文件sha1',
    'detail_driver': '存储驱动',
    'detail_url': '附件URL',
    'detail_status': '激活状态',
    'detail_update_time': '最后更新',
    'detail_update_ip': '更新IP',
    'detail_create_time': '添加时间',
    'detail_create_ip': '添加IP',

    'download_tip': '请选择要下载的附件',

    'delete_tip_title': '提示',
    'delete_tip_content': '确认要删除该附件吗？',
    'delete_tip_ok': '确定',
    'delete_tip_cancel': '取消'
  }
}
